export enum VideoContentTabs {
  DESCRIPTION = 'Description',
}
